import React from 'react';
import { useSelector } from 'react-redux';
import { FaDownload } from 'react-icons/fa';
import { selectMetadataKeyByRegion } from 'reducers/selectors/metadata';
import { selectUserProviders } from '../selectors/label.selector';
import '../components/Labels.scss';
import { getContentListV1 } from 'utils/homologacion/homologacion';
import { PROVIDER_DATA } from 'utils/homologacion/contants';

const useLabel = () => {
  const asset = useSelector(state => state.asset);
  const translations = useSelector(state => state.translations);

  const userProviders = useSelector(selectUserProviders);
  const providersConfig = useSelector(
    selectMetadataKeyByRegion('providers_label_configuration'),
  );

  const getChapa = (provider, type, contentType) => {
    const userType = userProviders[provider] || 'no_susc';
    let config = providersConfig[userType];
    config =
      config[provider] || config[provider.toLowerCase()] || config.default;

    const typeconfig = config[type] && config[type][contentType];
    return typeconfig;
  };

  const parseToRgb = backgroundColor => {
    let backgroundHex = backgroundColor;
    if (backgroundHex.length === 9) {
      const opacity = parseInt(backgroundHex.substring(1, 3), 16) / 255;
      backgroundHex = backgroundHex.substr(3, backgroundColor.length);
      const r = parseInt(backgroundHex.substring(0, 2), 16);
      const g = parseInt(backgroundHex.substring(2, 4), 16);
      const b = parseInt(backgroundHex.substring(4, 6), 16);

      backgroundHex = `rgba(${r},${g},${b},${opacity})`;
    }

    return backgroundHex;
  };

  const renderLabel = item => {
    const isLive = getContentListV1?.IsLive(item);

    const contentType = isLive ? 'live' : 'vod';
    const formatTypes = getContentListV1?.marketingType(item)?.split(',');
    const provider = getContentListV1?.provider(item, PROVIDER_DATA?.NAME)?.toUpperCase();

    const sheetsToShow = formatTypes.reduce((prev, type) => {
      const configChapa = getChapa(provider, type, contentType);

      if (!configChapa) return prev;
      return [...prev, ...configChapa];
    }, []);

    return (
      <div className="posterLabel">
        {sheetsToShow.map(sheet => {
          const style = {
            float: sheet.gravity,
          };
          if (sheet.type === 'image' && sheet.url.indexOf('icon') !== -1) {
            if (sheet.url.indexOf('download') !== -1) {
              return (
                <div className="posterLabel--icon" key={item.id} style={style}>
                  <FaDownload />
                </div>
              );
            }
          }
          if (sheet.url) {
            return (
              <div className="posterLabel--image" key={item.id} style={style}>
                <img src={asset[sheet.url]} alt="poster" />
              </div>
            );
          }
          const text = translations[sheet.text];

          if (!text || text === '') {
            return <></>;
          }

          const textHex = sheet.textColor;
          const backgroundColor = parseToRgb(sheet.backgroundColor);

          return (
            <div
              className="posterLabel--text"
              key={item.id}
              style={{ backgroundColor, color: textHex, ...style }}
            >
              {text}
            </div>
          );
        })}
      </div>
    );
  };

  return {
    renderLabel,
  };
};

export default useLabel;
